// 03-08-25
import { useEffect, useState } from "react";
import "./reporting.css";
import { data, useNavigate } from "react-router-dom";
import axios from "axios";
import * as XLSX from "xlsx";
import reportIcon from "../../assets/images/download-report.png";
import { jwtDecode } from "jwt-decode";

const ReportingPanel = () => {
  const navigate = useNavigate();
  const pubId = localStorage.getItem("account_id");
  const [startDate, setStartDate] = useState(getFormattedDate(7));
  const [endDate, setEndDate] = useState(getFormattedDate(1));
  const [selectedRange, setSelectedRange] = useState("last7");

  const [reportData, setReportData] = useState([]);
  const [dataHead, setDataHead] = useState([]);
  
  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const entriesPerPage = 20;
  const [allPageSummary, setAllPageSummary] = useState({
    request: 0,
    pageViews: 0,
    impression: 0,
    revenue: 0,
    ctrSum: 0,
    ctrCount: 0,
    ecpmSum: 0,
    ecpmCount: 0,
  });

  function toTwoDecimals(num) {
  return Math.floor(num * 100) / 100;
}
  // Utility Functions
  function getFormattedDate(daysAgo = 0) {
    const date = new Date();
    date.setDate(date.getDate() - daysAgo);
    return date.toISOString().split("T")[0];
  }

  const handleRangeChange = (e) => {
  const range = e.target.value;

  setSelectedRange(range);
  setErrorMessage("");
  setIsDisabled(false);

  switch (range) {
    // case "today":
    //   setStartDate(getFormattedDate(0));
    //   setEndDate(getFormattedDate(0));
    //   break;

    case "yesterday":
      setStartDate(getFormattedDate(1));
      setEndDate(getFormattedDate(1));
      break;

    case "last7":
      setStartDate(getFormattedDate(7));
      setEndDate(getFormattedDate(1));
      break;

    case "last15":
      setStartDate(getFormattedDate(15));
      setEndDate(getFormattedDate(1));
      break;

    case "last30":
      setStartDate(getFormattedDate(30));
      setEndDate(getFormattedDate(1));
      break;

    case "thisMonth" : {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      // const firstDayOfMonth  = new Date(
      //   today.getFullYear(),
      //   today.getMonth(),
      //   1
      // );
      const startDate = `${year}-${month}-01`;
      setStartDate(startDate);
      setEndDate(getFormattedDate(1));
      break;
    }

  case "lastMonth": {
  const today = new Date();

  const firstDayLastMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );

  const lastDayLastMonth = new Date(
    today.getFullYear(),
    today.getMonth(),
    0
  );

  const formatLocalDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  setStartDate(formatLocalDate(firstDayLastMonth));
  setEndDate(formatLocalDate(lastDayLastMonth));

  break;
}
    case "custom":
      // Keep existing dates
      break;

    default:
      break;
  }
};

  function formatDateToYYYYMMDD(date) {
    return new Date(date).toISOString().split("T")[0];
  }

  function validateDateRange(start, end) {
    const startDateObj = new Date(start);
    const endDateObj = new Date(end);
    const today = new Date();

    if (startDateObj > today) {
      setErrorMessage("Start Date cannot exceed today's date!");
      return true;
    }
    if (endDateObj > today) {
      setErrorMessage("End Date cannot exceed today's date!");
      return true;
    }
    if (endDateObj < startDateObj) {
      setErrorMessage("End Date cannot be before Start Date!");
      return true;
    }

    const diffInDays = (endDateObj - startDateObj) / (1000 * 60 * 60 * 24);
    if (diffInDays > 90) {
      setErrorMessage("Date range cannot exceed 3 months!");
      return true;
    }

    setErrorMessage("");
    return false;
  }

  // Event Handlers
  const handleStartDateChange = (e) => {
    const newStartDate = formatDateToYYYYMMDD(e.target.value);
    setStartDate(newStartDate);
    const hasError = validateDateRange(newStartDate, endDate);
    setIsDisabled(hasError);
  };

  const handleEndDateChange = (e) => {
    const newEndDate = formatDateToYYYYMMDD(e.target.value);
    setEndDate(newEndDate);
    const hasError = validateDateRange(startDate, newEndDate);
    setIsDisabled(hasError);
  };

  // const fetchReportData = async (page = 1) => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     if (token) {
  //       const decoded = jwtDecode(token);
  //       if (decoded.exp * 1000 < Date.now()) {
  //         // Token expired
  //         localStorage.removeItem("token");
  //         navigate("/");
  //         return;
  //       }
  //     }

  //     const response = await axios.post(
  //       `${process.env.REACT_APP_API_BASE_URL}/api/pub/dateWiseAdUnitReport?page=${page}`,
  //       { startDate, endDate },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //         },
  //       }
  //     );
  //     const data = response?.data?.data;
  //     setReportData(data.data || []);
  //     setTotalEntries(data.total || 0);
  //   } catch (error) {
  //     if (error.response?.status === 401) {
  //       localStorage.removeItem("token");
  //       navigate("/");
  //     } else {
  //       console.error("Error fetching data:", error);
  //     }
  //   }
  // };

  const fetchReportData = async (page = 1) => {
  try {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp * 1000 < Date.now()) {
        localStorage.removeItem("token");
        navigate("/");
        return;
      }
    }

    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/api/pub/dateWiseAdUnitReport?page=${page}`,
      { startDate, endDate },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      }
    );

    const data = response?.data?.data;
    const currentPageData = data.data || [];
    setReportData(currentPageData);
    setDataHead(data.columns);   
    console.log(data);
         
    setTotalEntries(data.total || 0);

    // Fetch all data to compute cumulative summary
    const pageSize = entriesPerPage;
    let allPages = [];
    let pageNum = 1;
    const total = data.total || 0;
    const totalPages = Math.ceil(total / pageSize);

    while (pageNum <= totalPages) {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/api/pub/dateWiseAdUnitReport?page=${pageNum}`,
        { startDate, endDate },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      const pageData = res?.data?.data?.data || [];
      allPages = allPages.concat(pageData);
      pageNum++;
    }

    // Compute summary
    let summary = {
      request: 0,
      pageViews:0,
      impression: 0,
      revenue: 0,
      ctrSum: 0,
      ctrCount: 0,
      ecpmSum: 0,
      ecpmCount: 0,
      clicks:0,
    };

    allPages.forEach((entry) => {
      summary.impression += Number(entry.imp) || 0;
      summary.request += Number(entry.requests) || 0;
      summary.pageViews += Number(entry.page_views) || 0;
      summary.revenue += toTwoDecimals(Number(entry.pubRev) )|| 0;      
      summary.clicks += Number((toTwoDecimals(entry?.ctr)*entry?.imp)/100 ) || 0;
      if (entry.ctr != null) {
          summary.ctrSum += Number(entry.ctr);
          summary.ctrCount++;
      }
      if (entry.pub_eCPM != null) {
          summary.ecpmSum += Number(entry.pub_eCPM);
          summary.ecpmCount++;
      }
      // if (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") {
      //   summary.request += Number(entry.requests) || 0;
      // }

      // if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      //   summary.revenue += (20 / 1000) * (Number(entry.imp) || 0);
      // } else {
      //   summary.revenue += Number(entry.pubRev) || 0;
      //   if (entry.ctr != null) {
      //     summary.ctrSum += Number(entry.ctr);
      //     summary.ctrCount++;
      //   }
      // }

      // if (
      //   pubId === "4eb8c253-7322-4912-ba12-713361d7c912" || pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da"
      // ) {
      //   if (entry.pub_eCPM != null) {
      //     summary.ecpmSum += Number(entry.pub_eCPM);
      //     summary.ecpmCount++;
      //   }
      // }
    });

    setAllPageSummary(summary);
    console.log(summary);
    
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      navigate("/");
    } else {
      console.error("Error fetching data:", error);
    }
  }
};

// download report logic
  const downloadReport = async () => {
    const token = localStorage.getItem("token");
      if (!token) {
        alert("No token found!");
        return;
      }
    // if (reportData.length === 0) {
    //   alert("No data available to download!");
    //   return;
    // }

    // const filteredData = reportData.map(({ date, domain, p_ad_display_name, imp, ctr, pubRev, pub_eCPM }) => ({
    //   Date: date,
    //   Domain: domain,
    //   "Ad Unit": p_ad_display_name,
    //   Impressions: imp,
    //   CTR: ctr,
    //   "Publisher Revenue": pubRev?.toFixed(2) || "N/A",
    //   "Publisher eCPM": pub_eCPM?.toFixed(2) || "N/A"
    // }));

    // const worksheet = XLSX.utils.json_to_sheet(filteredData);
    // const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

    // const fileName = `Report_${startDate}_to_${endDate}.xlsx`;
    // XLSX.writeFile(workbook, fileName);
    try {
      const pageSize = entriesPerPage;
      let page = 1;
      let allData = [];
      let totalPages = 1;
  
      do {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/api/pub/dateWiseAdUnitReport?page=${page}`,
          { startDate, endDate },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );
  
        const responseData = response?.data?.data;
        const pageData = responseData?.data || [];
        allData = [...allData, ...pageData];
  
        if (page === 1) {
          const total = responseData?.total || 0;
          totalPages = Math.ceil(total / pageSize);
          // allColumns = responseData?.columns || [];
        }
  
        page++;
      } while (page <= totalPages);
  
      if (allData.length === 0) {
        alert("No data available to download!");
        return;
      }  
      // const filteredData = allData.map(
      //   ({ date, domain, p_ad_display_name, imp, ctr, pubRev, pub_eCPM }) => ({
      //     Date: date,
      //     Domain: domain,
      //     "Ad Unit": p_ad_display_name,
      //     Impressions: imp,
      //     CTR: ctr,
      //     "Publisher Revenue": pubRev?.toFixed(2) || "N/A",
      //     "Publisher eCPM": pub_eCPM?.toFixed(2) || "N/A",
      //   })
      // );

      // const filteredData = allData.map(
      //   ({ date, domain, p_ad_display_name, requests, imp, ctr, pubRev, pub_eCPM,}) => {
      //     // ({ date, domain, p_ad_display_name, imp, ctr, requests, pubRev, pub_eCPM }) => {
      //     const baseData = {
      //       Date: date,
      //       Domain: domain,
      //       "Ad Unit": p_ad_display_name,
      //       // "Publisher eCPM" : pub_eCPM
      //       // Impressions: imp,
      //     };
      //     // if (pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      //     //   baseData["Request"] = requests;
      //     // }
      //     if (pubId == "4eb8c253-7322-4912-ba12-713361d7c912"){
      //          baseData["Request"] = requests;
      //     }
      //     baseData["Impressions"] = imp;

      //     if (pubId == "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      //       baseData["Pub Revenue"] = (20/1000)*imp;
      //     }
      //     if (pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      //       // baseData["Request"] = requests;
      //       baseData["CTR"] = ctr;
      //       baseData["Publisher Revenue"] = pubRev?.toFixed(2) || "N/A";
      //       // baseData["Publisher eCPM"] = pub_eCPM?.toFixed(2) || "N/A";
      //     }
      //     if (pubId == "4eb8c253-7322-4912-ba12-713361d7c912" || pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da"){
      //          baseData["Publisher eCPM"] = pub_eCPM?.toFixed(2) || "N/A";
      //     }
          
      //     return baseData;
      //   }
      // );
       
      let totalRequests = 0;
      let totalPageViews = 0;
      let totalImpressions = 0;
      let totalPubRevenue = 0;
      let totalClicks = 0;
      let ctrSum = 0, ctrCount = 0;
      let ecpmSum = 0, ecpmCount = 0;

      const filteredData = allData?.map(({ date, domain, p_ad_display_name, requests, page_views, imp, ctr, pubRev, pub_eCPM }) => {
        const baseData = {
          Date: date,
          Domain: domain,
          "Ad Unit": p_ad_display_name,
        };

        // Requests
        // if (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") {
        //   baseData["Request"] = requests;
        //   totalRequests += Number(requests) || 0;
        // }
        // {
        //   dataColumns.includes("requests") && 
        //   baseData["Request"] = requests;
        //   totalRequests += Number(requests) || 0;
        //   }
        if (dataHead.includes("requests")) {
            baseData["Requests"] = requests;
            totalRequests += Number(requests) || 0;
        }
        if (dataHead.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
            baseData["Page Views"] = page_views;
            totalPageViews += Number(page_views) || 0;
        } 
        // Impressions
        if (dataHead.includes("imp")) {
          baseData["Impressions"] = imp;
          totalImpressions += Number(imp) || 0;
        }
        // Pub Revenue
        // if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
        //   const calculatedRevenue = (20 / 1000) * imp;
        //   // baseData["Pub Revenue"] = calculatedRevenue.toFixed(2);
        //   baseData["Pub Revenue"] = toTwoDecimals(calculatedRevenue);
        //   totalPubRevenue += calculatedRevenue;
        // } else {
        //   baseData["CTR"] = ctr;
        //   if (ctr != null) {
        //     ctrSum += Number(ctr);
        //     ctrCount++;
        //   }
          // baseData["Publisher Revenue"] = pubRev?.toFixed(2) || "N/A";
           if (dataHead.includes("pubRev")) {
              const rev = pubRev != null ? toTwoDecimals(pubRev) : 0;
              // baseData["Pub Revenue"] = pubRev != null ? toTwoDecimals(pubRev) : "0";
              baseData["Pub Revenue"] = rev;
              totalPubRevenue += rev || 0;
            }
        // }
        // CTR
            if (dataHead.includes("ctr")) {
              if (ctr != null) {
                totalClicks += Number((ctr*imp)/100);
                ctrSum += Number(ctr);
                ctrCount++;
              }
              baseData["CTR"] = ctr != null ? toTwoDecimals(ctr) : "0";
            }
            // if (dataHead.includes("ctr")) {
            //   baseData["Clicks"] = ctr != null ? toTwoDecimals((ctr*imp)/100) : "0";
            //   totalClicks += Number((ctr*imp)/100);
            //   // if (ctr != null) {
            //   //     // totalClicks++;
            //   // }
            // }
        // eCPM
        // if (
        //   pubId === "4eb8c253-7322-4912-ba12-713361d7c912" ||
        //   pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da"
        // ) {
        //   // baseData["Publisher eCPM"] = pub_eCPM?.toFixed(2) || "N/A";
        //   baseData["Publisher eCPM"] = pub_eCPM != null ? toTwoDecimals(pub_eCPM) : "N/A";
        //   if (pub_eCPM != null) {
        //     ecpmSum += Number(pub_eCPM);
        //     ecpmCount++;
        //   }
        // }

        // PubeCPM 
        if (dataHead.includes("pub_eCPM")) {
            baseData["Publisher eCPM"] = pub_eCPM != null ? toTwoDecimals(pub_eCPM) : "0";
              if (pub_eCPM != null) {
                ecpmSum += Number(pub_eCPM);
                ecpmCount++;
              }
        }
        return baseData;
      });

      // Calculate Averages
      // const avgCTR = ctrCount > 0 ? (ctrSum / ctrCount).toFixed(2) : "N/A";
      const avgCTR = ctrCount > 0 ? toTwoDecimals((totalClicks / totalImpressions)*100) : "0";
      // const avgEcpm = ecpmCount > 0 ? (ecpmSum / ecpmCount).toFixed(2) : "N/A";
      const avgEcpm = ecpmCount > 0 ? toTwoDecimals((totalPubRevenue / totalImpressions)*1000): "0";

      // Prepare Summary Row
      const summaryRow = {
        Date: "Total",
        Domain: "",
        "Ad Unit": "",
      };

      // if (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") {
      //   summaryRow["Request"] = totalRequests;
      // }
      // if (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") {
      //   summaryRow["Request"] = totalRequests;
      // }
      
       if (dataHead.includes("requests")) summaryRow["Requests"] = totalRequests;
       if (dataHead.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e") summaryRow["Page Views"] = totalPageViews;
       if (dataHead.includes("imp")) summaryRow["Impressions"] = totalImpressions;
       if(dataHead.includes("pubRev")) summaryRow["Pub Revenue"] = toTwoDecimals(totalPubRevenue);
       if(dataHead.includes("ctr")) summaryRow["CTR"] = avgCTR;
       if(dataHead.includes("pub_eCPM")) summaryRow["Publisher eCPM"] = avgEcpm;

      // if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
      //   // summaryRow["Pub Revenue"] = totalPubRevenue.toFixed(2);
      //   summaryRow["Pub Revenue"] = toTwoDecimals(totalPubRevenue);
      // } else {
      //   summaryRow["CTR"] = avgCTR;
      //   // summaryRow["Publisher Revenue"] = totalPubRevenue.toFixed(2);
      //   summaryRow["Publisher Revenue"] = summaryRow["Publisher eCPM"] = avgEcpm;;
      // }

      // if (
      //   pubId === "4eb8c253-7322-4912-ba12-713361d7c912" ||
      //   pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da"
      // ) {
      //   summaryRow["Publisher eCPM"] = avgEcpm;
      // }

      // Append summary row for addition
      filteredData.push(summaryRow);



      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");
  
      const fileName = `Report_${startDate}_to_${endDate}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem("token");
        navigate("/");
      } else {
        console.error("Download error:", error);
        alert("Failed to download report.");
      }
    }
  };
// for summary at the bottom
const summaryData = {
  request: 0,
  pageViews: 0,
  impression: 0,
  revenue: 0,
  ctrSum: 0,
  ctrCount: 0,
  ecpmSum: 0,
  ecpmCount: 0,
};

reportData.forEach((entry) => {
  if (dataHead.includes("imp")){
    summaryData.impression += Number(entry.imp) || 0;
  }

  if(dataHead.includes("requests")) {
    summaryData.request += Number(entry.requests) || 0;
  }
  if(pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e"){
    if(dataHead.includes("page_views")) {
    summaryData.pageViews += Number(entry.pageViews) || 0;
  }
  }
   if (dataHead.includes("pubRev")){
    const rev = entry.pubRev != null ? toTwoDecimals(entry.pubRev) : 0;
    // summaryData.revenue += Number(entry.pubRev) || 0;
    summaryData.revenue += rev;
   }

   if(dataHead.includes("ctr") && entry.ctr != null ){
    summaryData.ctrSum += Number(entry.ctr);
    summaryData.ctrCount++;
   }
   if (dataHead.includes("pub_eCPM") && entry.pub_eCPM != null) {
    summaryData.ecpmSum += Number(entry.pub_eCPM);
    summaryData.ecpmCount++;
  }
  // if (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") {
  //   summaryData.request += Number(entry.requests) || 0;
  // }

  // if (pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3") {
  //   summaryData.revenue += (20 / 1000) * (Number(entry.imp) || 0);
  // } else {
  //   summaryData.revenue += Number(entry.pubRev) || 0;
  //   if (entry.ctr != null) {
  //     summaryData.ctrSum += Number(entry.ctr);
  //     summaryData.ctrCount++;
  //   }
  // }

  // if (
  //   pubId === "4eb8c253-7322-4912-ba12-713361d7c912" ||
  //   pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da"
  // ) {
  //   if (entry.pub_eCPM != null) {
  //     summaryData.ecpmSum += Number(entry.pub_eCPM);
  //     summaryData.ecpmCount++;
  //   }
  // }
});

// const avgCTR = summaryData.ctrCount ? (summaryData.ctrSum / summaryData.ctrCount).toFixed(2) : "N/A";
const avgCTR = summaryData.ctrCount ? toTwoDecimals(summaryData.ctrSum / summaryData.ctrCount) : "0";
// const avgEcpm = summaryData.ecpmCount ? (summaryData.ecpmSum / summaryData.ecpmCount).toFixed(2) : "N/A";
const avgEcpm = summaryData.ecpmCount ? toTwoDecimals(summaryData.ecpmSum / summaryData.ecpmCount) : "0";


  useEffect(() => {
    fetchReportData(currentPage);
  }, [currentPage]);


  // Pagination logic
  const indexOfLastEntry = currentPage * entriesPerPage;
  const indexOfFirstEntry = indexOfLastEntry - entriesPerPage;
  const currentEntries = reportData.slice(indexOfFirstEntry, indexOfLastEntry);
  const totalPages = Math.ceil(totalEntries / entriesPerPage);
  const pubRevenue = (15/1000);
  // define which columns you want to display
  const allowedColumns = ["date", "domain", "p_ad_display_name", "requests", "page_views", "imp", "ctr", "pubRev", "pub_eCPM"];
  // filter the API columns before rendering
  let visibleColumns = dataHead?.filter(col => {
  if (col === "page_views" && pubId !== "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
    return false; // hide page_views for other publishers
  }
  return allowedColumns.includes(col);;
});
  // const visibleColumns = dataHead?.filter(col => allowedColumns.includes(col));
//   if (pubId !== "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
//   visibleColumns = visibleColumns.filter(col => col !== "page_views");
// }
  const headerMapping = {
  date: "Date",
  domain: "Domain",
  p_ad_display_name: "Ad Unit",
  imp: "Impressions",
  ctr: "CTR",
  pubRev: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "Publisher Rev ($)" : "Publisher Rev ($)",
  requests:"Request",
  page_views:"Page Views",
  pub_eCPM: pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" ? "PubeCPM($)" : "PubeCPM($)",
};
  return (
    <section className="reporting mainContainer noscroll">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          setCurrentPage(1);
          fetchReportData(1);
        }}
      >
        {/* <div className="reportingDate mb-3 mt-3">
          <div className="col-5 mx-3">
            <label htmlFor="startDate">Start Date</label>
            <input
              type="date"
              className="form-control"
              id="startDate"
              value={startDate}
              onChange={handleStartDateChange}
            />
          </div>
          <div className="col-5">
            <label htmlFor="endDate">End Date</label>
            <input
              type="date"
              className="form-control"
              id="endDate"
              value={endDate}
              onChange={handleEndDateChange}
            />
          </div>
          <div className="col-2 mx-3 mt-4">
            <button type="submit" className="btn btn-primary" disabled={isDisabled}>
              Submit
            </button>
          </div>
        </div> */}
        {/* {errorMessage && <p style={{ color: "red" }} className="mx-4 my-0">{errorMessage}</p>} */}
        {/* <div className="reporting-filter-card">
          <div className="reportingDate">

            <div className="reporting-field">
              <label htmlFor="startDate">Start Date</label>
              <input
                type="date"
                id="startDate"
                value={startDate}
                onChange={handleStartDateChange}
              />
            </div>

            <div className="reporting-field">
              <label htmlFor="endDate">End Date</label>
              <input
                type="date"
                id="endDate"
                value={endDate}
                onChange={handleEndDateChange}
              />
            </div>

            <div className="reporting-submit-wrapper">
              <button
                type="submit"
                className="btn btn-primary reporting-submit"
                disabled={isDisabled}
              >
                Submit
              </button>
            </div>

          </div>

          {errorMessage && (
            <p className="reporting-error">
              {errorMessage}
            </p>
          )}
        </div> */}
        <div className="report-filter-card">
          <div className="report-filter-header">
            <div>
              <h4>
                <span className="filter-icon">⚙</span>
                Report Filters
              </h4>
              <p>
                Choose a predefined period or select Custom for a specific date range.
              </p>
            </div>

            <div className="filter-status">
              {selectedRange === "custom"
                ? "Custom Range"
                // : selectedRange === "today"
                //   ? "Today"
                  : selectedRange === "yesterday"
                    ? "Yesterday"
                    : selectedRange === "last7"
                      ? "Last 7 Days"
                      : selectedRange === "last15"
                        ? "Last 15 Days"
                        : selectedRange === "last30"
                          ? "Last 30 Days" : selectedRange === "lastMonth" ? "Last Month"
                          : "This Month"}
            </div>
          </div>


          <div className="report-filter-body">

            {/* Date Range */}
            <div className="report-filter-field range-field">
              <label htmlFor="dateRange">
                Date Range
              </label>

              <div className="input-with-icon">
                <span>📅</span>

                <select
                  id="dateRange"
                  value={selectedRange}
                  onChange={handleRangeChange}
                >
                  {/* <option value="today">Today</option> */}
                  <option value="yesterday">Yesterday</option>
                  <option value="last7">Last 7 Days</option>
                  <option value="last15">Last 15 Days</option>
                  <option value="last30">Last 30 Days</option>
                  <option value="thisMonth">This Month</option>
                  <option value="lastMonth">Last Month</option>
                  <option value="custom">Custom</option>
                </select>
              </div>
            </div>


            {/* Custom Start Date */}
            {selectedRange === "custom" && (
              <div className="report-filter-field">
                <label htmlFor="startDate">
                  Start Date
                </label>

                <input
                  type="date"
                  id="startDate"
                  value={startDate}
                  onChange={handleStartDateChange}
                />
              </div>
            )}


            {/* Custom End Date */}
            {selectedRange === "custom" && (
              <div className="report-filter-field">
                <label htmlFor="endDate">
                  End Date
                </label>

                <input
                  type="date"
                  id="endDate"
                  value={endDate}
                  onChange={handleEndDateChange}
                />
              </div>
            )}


            {/* Apply Button */}
            <div className="report-filter-action">
              <button
                type="submit"
                className="apply-report-btn"
                disabled={isDisabled}
              >
                <span>↻</span>
                Apply Report
              </button>
            </div>

          </div>


          {errorMessage && (
            <div className="report-filter-error">
              {errorMessage}
            </div>
          )}

        </div>
      </form>

      {/* <div className="mb-3 mx-3 d-flex justify-content-end">
        <button className="btn btn-success downlodeBtn" onClick={downloadReport}>
          Download <img src={reportIcon} alt="Download" />
        </button>
      </div> */}

      <div className="reporting-download">
        <button className="btn btn-success downlodeBtn" onClick={downloadReport}>
          Download
          <img src={reportIcon} alt="Download" />
        </button>
      </div>
  <div className="reporting-table-card">
    <div className="reporting-table-wrapper">
      <table className="reporting-table">
        <thead>
          <tr>
            <th>SN</th>
            {/* {             
              dataHead?.length > 0 ?
                visibleColumns.map((col, index) =>(
                    <th key={index}>{headerMapping[col] || col}</th>                              
                )) : ''
            } */}
            {visibleColumns?.map((col, index) => {
              // ✅ Hide Page Views if pubId does not match
              if (col === "page_views" && pubId !== "c79a2d5f-2dc7-41c7-8927-463bc022327e") {
                return null;
              }
              return (
                <th key={index}>{headerMapping[col] || {col}}</th>
              );
            })}
          </tr>
          {/* <tr> */}
            {/* <th>SN</th> */}
            {/* <th>Date</th> */}
            {/* <th>Domain</th> */}
            {/* <th>Ad Unit</th> */}
              {/* <th>{dataHead[7] === "requests" ? "Requests" : ""}</th>    */}

            {/* <th>{dataHead[8] === "imp" ? "Impression" : "" }</th> */}
            
              {/* (pubId == "f3a15f06-c726-4056-a67b-ae96ad22e7e3") ? */}
              {/* <th>{dataHead[10]} (INR)</th>  */}
           
              {/* (pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3") ?  */}
              <>
                {/* <th>{dataHead[9] === "ctr" ? "CTR" : ""}</th> */}
                {/* <th>{dataHead[10] === "pubRev" ? "PubRev" : ""} ($)</th> */}
                {/* { */}
                  {/* (pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da" || pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ? */}
                {/* <th>{dataHead[11] === "pub_eCPM" ? "PubeCPM" : ""} ($)</th> */}
                {/* } */}
              </>
            {/* : null */}
            
            {/* } */}

          {/* </tr> */}
        </thead>
        <tbody>
          {reportData.length > 0 ? (
            reportData.map((entry, index) => (
              <tr key={index}>
                <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                {/* <td>{entry.date}</td>
                <td>{entry.domain}</td>
                <td>{entry.p_ad_display_name}</td> */}
                {/* {
                  (pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ?  */}
                  {/* <td>{entry.requests}</td> */}
                {/* } */}
                {/* <td>{toTwoDecimals(entry.imp)}</td> */}
                {/* { */}
                  {/* // (pubId == "f3a15f06-c726-4056-a67b-ae96ad22e7e3") ?  */}
                  {/* // <td>{(pubRevenue*(entry.imp)).toFixed(2)}</td> : "" */}
                  {/* <td>{entry.imp != null ? toTwoDecimals(pubRevenue * entry.imp) : "N/A"}</td>  */}
                {/* } */}
                {
                  // pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3" ? (
                  <>
                    {/* <td>{entry.ctr != null ? toTwoDecimals(entry.ctr) : "0"}</td> */}
                    {/* <td>
                      {dataHead.includes("ctr") && (
                        <td>{entry.ctr != null ? toTwoDecimals(entry.ctr) : "N/A"}</td>
                      )}
                    </td> */}
                    {/* <td>{entry.pubRev?.toFixed(2) || "N/A"}</td> */}
                    {/* <td>{entry.pubRev != null ? toTwoDecimals(entry.pubRev) : "0"}</td> */}
                    {/* { */}
                      {/* (pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da" || pubId === "4eb8c253-7322-4912-ba12-713361d7c912") ? */}
                      {/* // <td>{entry.pub_eCPM?.toFixed(2) || "N/A"}</td> : null */}
                      {/* <td>{entry.pub_eCPM != null ? toTwoDecimals(entry.pub_eCPM) : "0"}</td> */}
                      {/* <td>{dataHead.includes("pub_eCPM") && (
                        <td>{entry.pub_eCPM != null ? toTwoDecimals(entry.pub_eCPM) : "N/A"}</td>
                      )}</td> */}
                      {/* } */}
                  </>
                //  ) : null
                }
                {dataHead.includes("date") && <td>{entry.date}</td>}
                {dataHead.includes("domain") && <td>{entry.domain}</td>}
                {dataHead.includes("p_ad_display_name") && <td>{entry.p_ad_display_name}</td>}  
                {dataHead.includes("requests") && <td>{entry.requests}</td>}
                {/* {dataHead.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (<td>{entry.page_views}</td>)} */}
                {dataHead.includes("page_views") && pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (
                    <td>{entry.page_views}</td>
                  )}
                {dataHead.includes("imp") && <td>{toTwoDecimals(entry.imp)}</td>}
                {dataHead.includes("ctr") && (
                  <td>{entry.ctr != null ? toTwoDecimals(entry.ctr) : "0"}</td>
                )}
                {dataHead.includes("pubRev") && (
                  <td>{entry.pubRev != null ? toTwoDecimals(entry.pubRev) : "0"}</td>
                )}
                {dataHead.includes("pub_eCPM") && (
                  <td>{entry.pub_eCPM != null ? toTwoDecimals(entry.pub_eCPM) : "0"}</td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              {/* <td colSpan="8" className="text-center">No data available</td> */}
              <td colSpan={visibleColumns?.length + 1} className="reporting-empty">
                No data available
              </td>
            </tr>
          )}
        </tbody>
        {/* <tfoot>
          <tr style={{ fontWeight: "bold", backgroundColor: "#f1f1f1" }}>
            <td colSpan={4}>Final Summary</td>
            
            {pubId === "4eb8c253-7322-4912-ba12-713361d7c912" && (
              <td>{summaryData.request}</td>
            )}

            <td>{summaryData.impression}</td>

            {pubId === "f3a15f06-c726-4056-a67b-ae96ad22e7e3" && (
              <td>{summaryData.revenue.toFixed(2)}</td>
            )}

            {pubId !== "f3a15f06-c726-4056-a67b-ae96ad22e7e3" && (
              <>
                <td>{avgCTR}</td>
                <td>{summaryData.revenue.toFixed(2)}</td>
                {(pubId === "4eb8c253-7322-4912-ba12-713361d7c912" ||
                  pubId === "fef9f4c2-fee9-4a39-ac97-32f9a03035da") && (
                  <td>{avgEcpm}</td>
                )}
              </>
            )}
          </tr>
        </tfoot> */}
        <tfoot>
          <tr style={{ fontWeight: "bold", backgroundColor: "#f1f1f1" }}>
            <td colSpan={4}>Total / Average (All Pages)</td>

            {dataHead?.includes("requests") && (<td style={{fontWeight:"bold",color:"#1e293b"}}>{allPageSummary?.request}</td>)}
            { pubId === "c79a2d5f-2dc7-41c7-8927-463bc022327e" && (
            dataHead?.includes("page_views") && (<td>{allPageSummary?.pageViews}</td>)
            )}
            {dataHead?.includes("imp") && <td>{allPageSummary?.impression}</td>}
              

            {/* <td>{allPageSummary.impression}</td> */}

              <>
              {dataHead?.includes("ctr") && (
                  <td>
                
                      {allPageSummary?.ctrCount
                      ? toTwoDecimals((allPageSummary?.clicks) / (allPageSummary?.impression)*100)
                      : "0"}
                  </td>
                )}
                {
                  dataHead?.includes("pubRev") && (
                 <td>{toTwoDecimals(allPageSummary?.revenue)}</td>
                 )}
                
                  {dataHead?.includes("pub_eCPM") && (
                      <td>
                
                        {allPageSummary?.ecpmCount
                        ? toTwoDecimals((allPageSummary?.revenue / allPageSummary?.impression)*1000)
                        : "0"}
                      </td>)}
              </>
          </tr>
        </tfoot>

      </table>
    </div>
  </div>
        {
          totalEntries > 20 ?       
          // <div className="pagination d-flex justify-content-center mt-3">
          <div className="reporting-pagination">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((number) => (
            <button
              key={number}
              onClick={() => setCurrentPage(number)}
              // className={`btn mx-1 ${currentPage === number ? "btn-primary" : "btn-outline-primary"}`}
              className={currentPage === number ? "btn btn-primary" : "btn btn-outline-primary"}>
              {number}
            </button>
          ))}
        </div> : null
        }

    </section>
  );
};

export default ReportingPanel;
